<template>
    <div class="wrap">
        <div class="head">
            <Head @changeOn="changeOn"></Head>
        </div>
        <div class="title">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/title.png">
        </div>
<!--        <div class="man">-->
<!--            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/man.png">-->
<!--        </div>-->
        <div class="content" ref="content" id="content">
            <div class="year-r year15">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2021-1.png"><!--21-->
            </div>
            <div class="year-l year14">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2017-1.png"><!--17-1-->
            </div>
            <div class="year-r year13">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2016-1.png"><!--16-->
            </div>
            <div class="year-l year12">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2015-1.png"><!--15-->
            </div>
            <div class="year-r year11">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2013-1.png"><!--13-->
            </div>
            <div class="year-l year10">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2010-1.png"><!--10-->
            </div>
            <div class="year-r year9">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2007-1.png"><!--07-->
            </div>
            <div class="year-l year8">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2005-1.png"><!--05-->
            </div>
            <div class="year-r year7">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2004-1.png"><!--04-->
            </div>
            <div class="year-l year6">-->
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/2003-1.png"><!--03-->
            </div>
            <div class="year-r year5">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/1999-2.png"><!--99-1-->
            </div>
            <div class="year-l year4">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/1999-1.png"><!--99-->
            </div>
<!--            <div class="year-l year4">-->
<!--                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/1995.png">&lt;!&ndash;95&ndash;&gt;-->
<!--            </div>-->
            <div class="year-r year3">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/1994-1.png"><!--94-->
            </div>
            <div class="year-l year2">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/1993-1.png"><!--93-->
            </div>
            <div class="year-r year1">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/history/1992-1.png"><!--92-->
            </div>
        </div>
    </div>
</template>

<script>

    import Head from "./Head"
    export default {
        data() {
            return {
                isOff:false,
                t:""
            }
        },
        components:{
          Head
        },
        methods:{
            toSchedule(){
                this.$router.push("/hz/schedule")
            },
            start(){
                let box = document.getElementById("content");
                if(box.scrollTop!=0){
                    box.scrollTop-=1
                }else{
                    clearInterval(this.t)
                }
            },
            changeOn(val){
                console.log("onOrOff="+val)
                if (val){
                    this.$parent.$refs.audio.pause();
                }else{
                    this.$parent.$refs.audio.play();
                }
            },
            changeOnOff(){
                let oAudio = document.querySelector("#audio");
                if(oAudio!=null){
                    this.tag= true
                    if(this.isOff){
                        console.log("222")
                        oAudio.play();//让音频文件开始播放
                    }else{
                        console.log("333")
                        oAudio.pause();//让音频文件暂停播放
                    }
                    this.isOff = !this.isOff;
                }

            },
        },
        destroyed() {
          clearInterval(this.t)
        },
        mounted() {
            console.log("mounted")
            // let scrollHeight =  this.$refs.content.scrollHeight;
            // // let offsetHeight =  this.$refs.content.offsetHeight;
            // console.log("scrollheight="+scrollHeight)
            // // console.log("offsetHeight="+offsetHeight)
            // let content = document.getElementById("content");
            // content.scrollTop = scrollHeight
            // this.t = setInterval(this.start,30)	//10毫秒刷新一次

            let _this = this
            setTimeout(function () {
                //调用需要执行的方法
                console.log("mounted")
                let scrollHeight =  _this.$refs.content.scrollHeight;
                // let offsetHeight =  this.$refs.content.offsetHeight;
                console.log("scrollheight="+scrollHeight)
                let content = document.getElementById("content");
                content.scrollTop = scrollHeight
                _this.t = setInterval(_this.start,30)	//10毫秒刷新一次
            },1000)

        },

    }
</script>

<style scoped lang="scss">
    .wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/bg-line-1.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .head{
        margin-top: 0px;
    }

    .title{
        width: 100%;
        margin-top: -10px;
        img{
            width: 70%;
        }
        opacity: 0;
        animation: wordmove 1s ease .3s forwards;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 0.3s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: wordmove;
    }
    .content{
        flex-grow: 1;
        position: relative;
        overflow: scroll;
        .line{
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 4;
        }
    }

    .item{
        width: 100%;
    }

    .year{
        position: absolute;
    }

    .year-l{
        width: 50%;
        margin-left: 2%;
    }

    .year-r{
        width: 48%;
        margin-left: 50%;
    }


    .year1{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 1s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
        margin-bottom: 10px;

    }
    .year2{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 2s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year3{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 3s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year4{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 4s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year5{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 5s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year6{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 6s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year7{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 7s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year8{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 8s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year9{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 9s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year10{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 10s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year11{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 11s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year12{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 12s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year13{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 13s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year14{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 14s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year15{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 15s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }
    .year16{
        z-index: 4;
        opacity: 0;
        animation: flipInX;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-delay: 16s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: flipInX;
    }

    .man {
        position: absolute;
        bottom: 0%;
        left: 49%;
        width: 5%;
        opacity: 0;
        animation: manmove 4s linear 1.6s forwards;
        animation-duration: 10s;
        animation-timing-function: linear;
        animation-delay: 0.5s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
        animation-name: manmove;
    }

    body img{
        width: 100%;
        height: 100%;
        vertical-align: top;
    }

    .isOff{
        position: absolute;
        z-index: 100;
        top: 7%;
        right: 5%;
        img{
            width: 30px;
        }
    }

    .isOn{
        position: absolute;
        z-index: 100;
        top: 7%;
        right: 5%;
        animation: rotating 2s linear infinite;
        img{
            width: 30px;
        }
    }


    @keyframes wordmove {
        0% {
            opacity: 0;
            -webkit-transform: matrix(2, 0, 0, 2, 0, 0);
        }
        100% {
            opacity: 1;
            -webkit-transform: matrix(1, 0, 0, 1, 0, 0);
        }
    }

    @keyframes flipInX {
        0% {
            -webkit-transform: perspective(400px) rotateX(90deg);
            transform: perspective(400px) rotateX(90deg);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
            opacity: 0;
        }
        40% {
            -webkit-transform: perspective(400px) rotateX(-20deg);
            transform: perspective(400px) rotateX(-20deg);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        60% {
            -webkit-transform: perspective(400px) rotateX(10deg);
            transform: perspective(400px) rotateX(10deg);
            opacity: 1;
        }
        80% {
            -webkit-transform: perspective(400px) rotateX(-5deg);
            transform: perspective(400px) rotateX(-5deg);
        }
        100% {
            -webkit-transform: perspective(400px);
            transform: perspective(400px);
            opacity: 1;
        }
    }

    @keyframes manmove {
        0% {
            opacity: 1;
            bottom: 0%;
        }
        80% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            bottom: 60%;
        }
    }

    @keyframes rotating {
        from { -webkit-transform: rotate(0) }
        to { -webkit-transform: rotate(360deg) }
    }

    ::-webkit-scrollbar{
        width: 0;
    }

</style>